import React from 'react';
import { criarAgentesRecebedoresDs } from '../DataSources';
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label
} from 'devextreme-react/form';
import UserInfo from "../UserInfo";
import { Popup } from 'devextreme-react/popup';
import { ButtonItem } from "devextreme-react/tree-list";

const _novoImprimirImovelTemplate = {
    "id": undefined,
    "todos": false,
    "ativos": false,
    "inativos": false,
    "imovelContribuinteInvalido": false,
    "modelo": undefined,
};


export default class ImprimirImoveisPopup extends React.Component {
    constructor(props) {
        super(props);
        console.log(this);
        //this.arrecadacaoDs = criarArrecadacaoDs();
        //console.log(this.arrecadacaoDs);
        //console.log(this.arrecadacaoDs.byKey);
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.selectOption = this.selectOption.bind(this);
        //this.saidaProgramada = false;
        _novoImprimirImovelTemplate.prefeituraId = UserInfo.getPrefeitura();
        this.state = this.props.match.params.id == undefined
            ? _novoImprimirImovelTemplate
            : {};

        let modelos = [
            { id: 1, descricao: "Modelo 1" },
            { id: 2, descricao: "Modelo 2" },
            { id: 3, descricao: "Modelo 3" },
        ]

        this.escolherModelo = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            placeholder: "Escolher...",
            dataSource: modelos,
            valueExpr: "id",
            displayExpr: "descricao"
        }
    }


    // componentDidMount() {
    //     if (this.props.match.params.id !== undefined) {
    //         this.arrecadacaoDs.byKey(this.props.match.params.id)
    //             .then(data => {
    //                 if (data == undefined) {
    //                     notify("Arrecadação não encontrada.", "error");
    //                     this.props.history.push("/home");
    //                 }
    //                 this.setState(data);
    //             })
    //             .catch(erro => {
    //                 notify(erro, "error");
    //                 this.props.history.goBack();
    //             });

    //     }
    // }

    render() {
        return (
            <Popup
                visible={true}
                dragEnabled={false}
                closeOnOutsideClick={true}
                showTitle={true}
                width={'80%'}
                height={'80%'}
                title="Imprimir Imóveis">
                <div className={'content-block dx-card responsive-paddings'}>
                    <Form formData={this.state} colCount={3}>
                        <GroupItem colSpan={3} colCount={3}>
                            <SimpleItem
                                dataField={'todos'}
                                editorType={'dxCheckBox'}
                                editorOptions={{onValueChanged: this.selectOption}}>
                                <Label text="Todos" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'ativos'}
                                editorType={'dxCheckBox'}
                                editorOptions={{onValueChanged: this.selectOption}}>
                                <Label text="Ativos" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'inativos'}
                                editorType={'dxCheckBox'}
                                editorOptions={{onValueChanged: this.selectOption}}>
                                <Label text="Inativos" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'modelo'}
                                editorType={'dxLookup'}
                                editorOptions={this.escolherModelo}
                                colSpan={3}>
                                <Label text="Modelo" />
                            </SimpleItem>
                            <SimpleItem
                                dataField={'imovelContribuinteInvalido'}
                                editorType={'dxCheckBox'}>
                                <Label text="Somente imóveis com contribuintes que possuem CPF/CNPJ inválidos." />
                            </SimpleItem>
                        </GroupItem>
                    </Form>
                    <br></br>
                    <Form>
                        <GroupItem colCount={6}>
                            <ButtonItem horizontalAlignment={'center'} buttonOptions={{ type: "success", text: "Salvar", onClick: this.ok }} />
                            <ButtonItem horizontalAlignment={'center'} buttonOptions={{ type: "warn", text: "Cancelar", onClick: this.cancel }} />
                        </GroupItem>
                    </Form>
                </div>
            </Popup>
        );
    }

    selectOption(e){
        console.log("Mensagem")
        console.log(e);
        if(e.previousValue == true){
            
        }
        if(this.state.ativos==true){
            this.setState({
                ativos: true,
                inativos: false,
                todos: false
            })
        }
        if(this.state.inativos==true){
            this.setState({
                ativos: false,
                inativos: true,
                todos: false
            })
        }
        if(this.state.todos==true){
            this.setState({
                ativos: false,
                inativos: false,
                todos: true
            })
        }
    }

    ok() {
        notify("OK");

    }

    cancel() {
        notify("Cancelado", "warning");
        this.props.history.goBack();
    }
}
